<template>
    <div class="middle-banner text-center">
        <b-container>
            <b-row>
                <b-col>
                    <img src="../assets/img/img_sofashionsoeasy.svg" alt="">
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>

.middle-banner{
    width: 100%;
    background: #000;
    padding: 2% 0;
}

@media (max-width: 1600px) {
    img{
        max-width: 600px;
    }
}
@media (max-width: 768px) {
    .middle-banner{
        padding: 5% 0;
    }
    img{
        width: 80%;
    }
}

</style>